import { createRouter, createWebHistory } from "vue-router";
import { i18n } from './i18n.js'
import store from './store'

export default createRouter({
  history: createWebHistory("/"),  
  routes: [
    {
      path: '/pl',
      redirect: '/pl/de'
    },
    {
      path: '/pl/:lang',
      name: 'pulverlagerliste',
      components: {
        appToolbar: () => import('@/components/PLToolbar.vue'),
        appContent: () => import('@/components/PLContent.vue')
      },
      beforeEnter(to, from, next)
      {
        const lang=to.params.lang;
        if (!['de','fr','en'].includes(lang))
          return next('/pl/de');
        if (i18n.global.locale !== lang)
          i18n.global.locale=lang;
        
        var plConfig = store.getters.plConfig;
        plConfig.plTitle = i18n.global.t("message.plliste");
        store.dispatch("setPLConfig", plConfig);
        store.dispatch("setSelectedLanguage", lang);

        return next();
      }
    }
  ]

})
